/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

// Summary And Greeting Section


const illustration = {
  animated: true // set to false to use static SVG
};

const greeting = {
  username: "Hai Nguyen",
  title: "Hi there, I'm Hai",
  subTitle:
    "A technology leader with 18+ years of experience building and scaling digital banks from the ground up. I specialize in cloud-native architectures, microservices, and agile transformation—empowering organizations to innovate, modernize, and deliver customer-centric digital solutions at scale. Passionate about leveraging technology to disrupt traditional financial services and building high-performing engineering teams.",
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  linkedin: "https://www.linkedin.com/in/hainguyenminh/",
  twitter: "https://twitter.com/minhhai8507",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I Do",
  skills: [
    "⚡ Design and deliver cloud-native, microservices-based solutions for scale and resilience",
    "⚡ Build and lead high-performing engineering teams with a focus on culture and excellence",
    "⚡ Drive digital transformation in banking and financial services through innovation and modern architecture"
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Infrastructure as code",
      fontAwesomeClassname: "fas fa-code"
    },
    {
      skillName: "JavaScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "reactjs",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "nodejs",
      fontAwesomeClassname: "fab fa-node"
    },
    {
      skillName: "swift",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "android",
      fontAwesomeClassname: "fab fa-android"
    },
    {
      skillName: "sql-database",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "aws",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Java",
      fontAwesomeClassname: "fab fa-java"
    },
    {
      skillName: "docker",
      fontAwesomeClassname: "fab fa-docker"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "AWS Certified Solutions Architect - Associate",
      logo: require("./assets/images/aws.png"),
      subHeader: "Amazon Web Services",
      duration: "2022 - 2025"
    },
    {
      schoolName: "CKA: Certified Kubernetes Administrator",
      logo: require("./assets/images/cka.png"),
      subHeader: "The Linux Foundation",
      duration: "2022 - 2025"
    },
    {
      schoolName: "Vietnam National University, Hanoi",
      logo: require("./assets/images/vnu-logo.png"),
      subHeader: "Master of Science in Information System",
      duration: "2009 - 2011"
    },
    {
      schoolName: "Military Technical Academy",
      logo: require("./assets/images/mta-logo.png"),
      subHeader: "Bachelor of Engineering in Information System",
      duration: "2003 - 2008"
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Engineering Management", //Insert stack or technology you have experience in
      progressPercentage: "95%" //Insert relative proficiency in percentage
    },
    {
      Stack: "Solution Architecture",
      progressPercentage: "95%"
    },
    {
      Stack: "Microservices & Event-Driven Architecture",
      progressPercentage: "95%"
    },
    {
      Stack: "Cloud Platforms (AWS, Azure)",
      progressPercentage: "85%"
    },
    {
      Stack: "Software Craftsmanship",
      progressPercentage: "85%"
    },
    {
      Stack: "Agile & DevOps Practices",
      progressPercentage: "90%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
     {
      role: "Head of Technology, Payment",
      company: "NAB",
      companylogo: require("./assets/images/nab-logo.png"),
      date: "Oct 2025 – Present",
      desc: "Leading <strong>strategic transformation</strong> of Payment Technology for one of Australia's largest banks, driving <strong>AI-native architecture</strong> and real-time payment innovation across the digital ecosystem.",
      descBullets: [ "<strong>Next-Gen Payments Platform:</strong> Spearheading the design and delivery of a <strong>real-time payments experience</strong> leveraging cloud-native microservices, event-driven architecture, and AI/ML capabilities for enterprise-scale transaction processing",
        "<strong>Engineering Excellence at Scale:</strong> Building high-performing engineering teams and embedding DevSecOps practices to accelerate delivery velocity while maintaining enterprise-grade reliability and security",
        "<strong>Innovation & AI Integration:</strong> Pioneering native AI integration for fraud detection, personalized customer experiences, and intelligent payment routing, positioning NAB at the forefront of digital payments innovation"
      ]
    },
    {
      role: "First Vice President, Head of Digital Technology",
      company: "Security Bank Corporation",
      companylogo: require("./assets/images/SBC-logo.jpg"),
      date: "May 2023 – Oct 2025",
      desc: "Led end-to-end digital transformation for a major Philippine banking institution, overseeing <strong>multidisciplinary teams</strong> across Architecture, Engineering, DevOps/SRE, UI/UX, and QA to deliver mission-critical banking platforms.",
      descBullets: ["<strong>Digital Platform Transformation:</strong> Orchestrated enterprise-wide migration to <strong>cloud-native microservices architecture</strong>, significantly reducing infrastructure costs while enabling rapid feature delivery and improved scalability",
        "<strong>Engineering & Product Velocity:</strong> Established modern SDLC practices, automated CI/CD pipelines, and engineering standards that dramatically increased deployment frequency while improving quality and reducing production incidents",
        "<strong>Site Reliability & Scale:</strong> Built comprehensive SRE capability for digital banking platforms, implementing observability, chaos engineering, and auto-scaling to ensure high availability and resilience at enterprise scale",
        "<strong>Customer Experience Innovation:</strong> Led design system and UX transformation that significantly improved customer satisfaction scores and drove substantial growth in digital banking adoption",
        "<strong>Quality & Compliance:</strong> Architected automated testing frameworks and regulatory compliance systems, ensuring security and compliance standards across all digital banking services"
      ]
    },
    {
      role: "Engineering Manager",
      company: "NAB",
      companylogo: require("./assets/images/nab-logo.png"),
      date: "June 2020 – March 2023",
      desc: "Led <strong>multiple cross-functional engineering squads</strong> delivering critical banking capabilities for millions of customers, driving technical excellence and agile transformation across retail banking domain.",
      descBullets: [ "<strong>High-Performing Teams:</strong> Built and scaled multiple engineering teams from ground up, achieving exceptional employee engagement and retention through mentorship, career development, and fostering psychological safety",
        "<strong>Delivery Excellence:</strong> Delivered major product releases consistently on-time and on-budget, implementing trunk-based development, automated testing, and continuous deployment practices that significantly reduced lead time",
        "<strong>Technical Innovation:</strong> Championed adoption of <strong>Domain-Driven Design</strong>, event sourcing, and CQRS patterns, modernizing legacy systems while maintaining zero-downtime migrations",
        "<strong>Agile Transformation:</strong> Led agile coaching and transformation initiatives across multiple teams, establishing communities of practice and engineering standards adopted bank-wide",
        "<strong>Recognition:</strong> Awarded <strong>NAB HONOUR</strong> (highest company accolade) for exceptional leadership and delivering outstanding business outcomes"
      ]
    },
    {
      role: "Senior Solution Architect",
      company: "Manulife",
      companylogo: require("./assets/images/manulife.png"),
      date: "Mar 2019 – May 2020",
      desc: "Architected and delivered <strong>regional ePOS (electronic Point of Sale) platform</strong> across Hong Kong and Singapore, enabling financial advisors to process insurance applications digitally with dramatically enhanced efficiency and compliance.",
      descBullets: [ "<strong>Enterprise Solution Architecture:</strong> Designed and implemented <strong>cloud-native microservices platform</strong> using React, Node.js, and AWS, dramatically reducing policy issuance time and improving operational efficiency",
        "<strong>Regional Platform Delivery:</strong> Led end-to-end delivery across multiple markets, coordinating with cross-functional teams and ensuring compliance with local regulations and security requirements",
        "<strong>Technical Excellence:</strong> Established architecture standards, code review practices, and technical design patterns adopted across Manulife Asia, mentoring developers to elevate engineering capability",
        "<strong>Business Impact:</strong> Platform achieved strong advisor adoption and processed significant insurance premium volume, substantially improving advisor productivity and customer satisfaction"
      ]
    },
    {
      role: "Head of Engineering / Solution Architect",
      company: "Commonwealth Bank of Australia",
      companylogo: require("./assets/images/cba-logo.jpg"),
      date: "Jul 2014 – Feb 2019",
      desc: "Founded and scaled engineering for <strong>TymeBank</strong> (South Africa's first digital bank), architecting a <strong>cloud-native, microservices platform</strong> from ground zero to serving <strong>over 3 million customers</strong>—one of the fastest-growing digital banks globally.",
      descBullets: [ "<strong>Digital Bank from Zero to Scale:</strong> Architected and delivered complete banking platform using <strong>event-driven microservices</strong>, Kubernetes, and AWS, achieving enterprise-grade availability and scalability for high-volume transaction processing",
      "<strong>Engineering Foundation & Culture:</strong> Built engineering organization from the ground up, establishing world-class DevOps culture, CI/CD automation with continuous deployment, and software craftsmanship practices that became industry benchmarks",
      "<strong>Technical Innovation:</strong> Pioneered <strong>CQRS and Event Sourcing</strong> at scale, enabling real-time analytics, comprehensive audit compliance, and temporal query capabilities across the entire banking domain",
      "<strong>Business Impact:</strong> Platform enabled TymeBank to achieve exceptional customer acquisition efficiency and rapid time-to-profitability, disrupting the traditional banking model in South Africa",
      "<strong>Team Development:</strong> Mentored numerous engineers to senior and lead roles through hands-on coaching, technical training programs, and creating psychological safety for experimentation and growth"]},
    {
      role: "Senior Executive Officer",
      company: "Vietnam International Bank",
      companylogo: require("./assets/images/vib-logo.png"),
      date: "Oct 2013 – June 2014",
      desc: "Led digital channels and payment integration services for one of Vietnam's leading commercial banks, modernizing customer-facing platforms and payment infrastructure.",
      descBullets: [ "<strong>Digital Banking Platforms:</strong> Managed end-to-end delivery of Internet Banking, Mobile Banking, and SMS Banking services for retail and corporate customers",
      "<strong>Payment Integration:</strong> Led integration of payment gateways, card processing systems, and inter-bank transfers, enabling real-time transaction processing across multiple channels",
      "<strong>Contact Center Systems:</strong> Architected and delivered omnichannel contact center platform integrating IVR, web chat, and CRM systems for improved customer service"]    
    }]
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: "Achievements & Recognition 🏆",
  subtitle:
    "Speaking engagements, awards, and memorable moments from my journey",

  achievementsCards: [
    {
      title: "DroidCon Vietnam 2017",
      subtitle:
        "Speaker at <strong>DroidCon Vietnam</strong> on best practices for building <strong>quality enterprise mobile applications</strong>",
      image: require("./assets/images/droidconvn.jpg"),
      footerLink: [
        {
          name: "Speaker"
        },
        {
          name: "Android",
        },
        {
          name: "Software Craftsmanship",
        }
      ]
    },
    {
      title: "Digital Bank Hackathon",
      subtitle:
        "Won both <strong>People's Choice</strong> and <strong>Business awards</strong> for an AI-powered chatbot solution integrated with <em>Facebook Messenger</em>",
      image: require("./assets/images/hackathon.jpg"),
      footerLink: [
        {
          name: "Hackathon Winner"
        },
        {
          name: "Innovation"
        }
      ]
    },

    {
      title: "Microservices Meetup",
      subtitle: "Sharing experience in building <strong>digital banks from the ground up</strong> and lessons learned in <strong>distributed systems</strong>",
      image: require("./assets/images/microservices.jpeg"),
      footerLink: [
        {
          name: "Speaker"},
        {
          name: "Microservices"
        },
        {
          name: "Distributed Systems"
        }
      ]
    },
    {
      title: "Vietnam Web Summit 2022",
      subtitle: "Keynote on <strong>\"How NAB builds technology to support 8 million customers\"</strong> — sharing enterprise engineering at scale",
      image: require("./assets/images/vnws-2022.jpeg"),
      footerLink: [
        {
          name: "Speaker"},
        {
          name: "Vietnam Web Summit 2022"
        },
        {
          name: "Enterprise Engineering"
        }
      ]
    },
    {
      title: "NAB HONOUR",
      subtitle: "<strong>NAB Honour</strong> is the highest accolade at NAB. It celebrates colleagues who represent the <strong>best of the best</strong> and are outstanding role models of How We Work.",
      image: require("./assets/images/nab-honour.jpg"),
      footerLink: [
        {
          name: "HONOUR"},
        {
          name: "Best of the best"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: "Get In Touch",
  subtitle: "Let's connect and explore opportunities to collaborate ☕",
  number: "☎️ +84 972 326 076",
  email_address: "📧 me@hainguyenminh.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

export {
  illustration,
  greeting,
  socialMediaLinks,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  achievementSection,
  contactInfo,
  twitterDetails
};
